export const GA_MEASUREMENT_ID = process.env.NEXT_PUBLIC_GA_MEASUREMENT_ID;

declare global {
  interface Window {
    gtag: (...args: unknown[]) => void;
  }
}

export function trackEvent(action: string, params?: Record<string, string | number | boolean>) {
  if (typeof window !== 'undefined' && window.gtag) {
    window.gtag('event', action, params);
  }
}

export function trackFunnelStep(step: number, stepName: string) {
  trackEvent('funnel_step_complete', {
    step_number: step,
    step_name: stepName,
  });
}

export function trackPaymentComplete(orderId: string, amount: number) {
  trackEvent('purchase', {
    transaction_id: orderId,
    value: amount,
    currency: 'KRW',
  });
}
